/**
 * Custom logging utility that respects environment settings
 * In development: shows all logs except errors are always shown
 * In production: only shows errors
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isTest = process.env.NODE_ENV === 'test';
const forceDebug = process.env.REACT_APP_FORCE_DEBUG === 'true';

// Show logs in development OR when force debug is enabled
const shouldShowLogs = isDevelopment || forceDebug;

export const logger = {
  /**
   * Debug logs - only shown in development
   * Use for detailed debugging information
   */
  debug: (...args: any[]) => {
    if (shouldShowLogs) {
      console.log('[DEBUG]', ...args);
    }
  },

  /**
   * Info logs - only shown in development
   * Use for general information
   */
  info: (...args: any[]) => {
    if (shouldShowLogs) {
      console.info('[INFO]', ...args);
    }
  },

  /**
   * Warning logs - only shown in development
   * Use for warnings that don't break functionality
   */
  warn: (...args: any[]) => {
    if (shouldShowLogs) {
      console.warn('[WARN]', ...args);
    }
  },

  /**
   * Error logs - always shown (both development and production)
   * Use for errors that need attention
   */
  error: (...args: any[]) => {
    console.error('[ERROR]', ...args);
  },

  /**
   * Timing logs - only shown in development
   * Use for performance timing information
   */
  timing: (...args: any[]) => {
    if (shouldShowLogs) {
      console.log('[TIMING]', ...args);
    }
  },

  /**
   * Critical logs - only shown in development
   * Use for critical debugging information
   */
  critical: (...args: any[]) => {
    if (shouldShowLogs) {
      console.log('[CRITICAL]', ...args);
    }
  },

  /**
   * Important logs - only shown in development
   * Use for important information that should be highlighted
   */
  important: (...args: any[]) => {
    if (shouldShowLogs) {
      console.log('[IMPORTANT]', ...args);
    }
  }
};
